if (!customElements.get('yotpo-reviews-section')) {
  customElements.define(
    'yotpo-reviews-section',
    class YotpoReviewsSection extends HTMLElement {
      /* ------------------------------------------------------------------ */
      /*  State                                                              */
      /* ------------------------------------------------------------------ */
      #state = {
        reviews: [],
        totalReviews: 0,
        reviewPage: 1,
        perPage: 3,
        averageScore: 0,
        starDistribution: {},
        qa: [],
        qaWindowStart: 0,
        images: [],
        ratingFilter: 0,
        searchQuery: '',
        loading: true,
        error: null,
      };

      #debounceTimer = null;
      #observer = null;

      /* ------------------------------------------------------------------ */
      /*  Lifecycle                                                          */
      /* ------------------------------------------------------------------ */
      connectedCallback() {
        this.#observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.#observer.unobserve(this);
                this.#fetchAll();
              }
            });
          },
          { rootMargin: '0px 0px 400px 0px' }
        );
        this.#observer.observe(this);
      }

      disconnectedCallback() {
        if (this.#observer) this.#observer.disconnect();
      }

      /* ------------------------------------------------------------------ */
      /*  Getters                                                            */
      /* ------------------------------------------------------------------ */
      get #key() {
        return this.dataset.yotpoKey;
      }

      get #productId() {
        return this.dataset.productId;
      }

      get #base() {
        return 'https://api-cdn.yotpo.com';
      }

      /* ------------------------------------------------------------------ */
      /*  SVG icons                                                          */
      /* ------------------------------------------------------------------ */
      get #thumbUpSVG() {
        return '<svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.65454 4.68473H12.7273C13.0648 4.68473 13.3885 4.81882 13.6272 5.0575C13.8659 5.29619 14 5.61991 14 5.95746V7.29637C14.0002 7.46269 13.9677 7.62743 13.9045 7.78128L11.935 12.5635C11.887 12.6801 11.8054 12.7798 11.7005 12.85C11.5957 12.9201 11.4725 12.9575 11.3464 12.9575H0.636364C0.467589 12.9575 0.305728 12.8904 0.186387 12.7711C0.0670452 12.6517 0 12.4899 0 12.3211V5.95746C0 5.78868 0.0670452 5.62682 0.186387 5.50748C0.305728 5.38814 0.467589 5.32109 0.636364 5.32109H2.85218C2.95406 5.32112 3.05446 5.29668 3.14493 5.24984C3.2354 5.203 3.31331 5.13512 3.37209 5.05191L6.84218 0.134731C6.88605 0.0725664 6.95074 0.0281786 7.02452 0.00961572C7.09831 -0.00894717 7.1763 -0.000456173 7.24436 0.0335492L8.39873 0.610731C8.72359 0.773107 8.98312 1.04175 9.13419 1.37202C9.28526 1.7023 9.31878 2.07432 9.22918 2.42628L8.65454 4.68473ZM3.81818 6.33164V11.6847H10.92L12.7273 7.29637V5.95746H8.65454C8.46071 5.95743 8.26944 5.91313 8.09533 5.82793C7.92122 5.74273 7.76887 5.61889 7.6499 5.46586C7.53093 5.31282 7.4485 5.13464 7.40887 4.94489C7.36925 4.75515 7.37349 4.55886 7.42127 4.371L7.99591 2.11319C8.01389 2.04276 8.00722 1.96829 7.977 1.90219C7.94678 1.83608 7.89484 1.78231 7.82982 1.74982L7.40918 1.53982L4.41191 5.78564C4.25282 6.01091 4.04918 6.19546 3.81818 6.33164ZM2.54545 6.59382H1.27273V11.6847H2.54545V6.59382Z" fill="#2C2C2C"/></svg>';
      }

      get #thumbDownSVG() {
        return '<svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.34545 8.27273H1.27273C0.93518 8.27273 0.611456 8.13864 0.372774 7.89995C0.134091 7.66127 6.77275e-07 7.33755 6.77275e-07 7V5.66109C-0.000170899 5.49477 0.0322586 5.33003 0.0954552 5.17618L2.06564 0.394545C2.11354 0.277934 2.19501 0.178179 2.29969 0.107935C2.40438 0.0376913 2.52757 0.00012439 2.65364 0H13.3636C13.5324 0 13.6943 0.0670452 13.8136 0.186387C13.933 0.305728 14 0.467589 14 0.636364V7C14 7.16877 13.933 7.33063 13.8136 7.44998C13.6943 7.56932 13.5324 7.63636 13.3636 7.63636H11.1478C11.0459 7.63634 10.9455 7.66077 10.8551 7.70761C10.7646 7.75446 10.6867 7.82234 10.6279 7.90554L7.15782 12.8221C7.11395 12.8843 7.04926 12.9286 6.97548 12.9472C6.90169 12.9658 6.8237 12.9573 6.75564 12.9233L5.60127 12.3455C5.27641 12.1831 5.01688 11.9144 4.86581 11.5842C4.71474 11.2539 4.68122 10.8819 4.77082 10.5299L5.34545 8.27273ZM10.1818 6.62582V1.27273H3.08L1.27273 5.66109V7H5.34545C5.53929 7.00003 5.73056 7.04433 5.90467 7.12953C6.07878 7.21472 6.23113 7.33856 6.3501 7.4916C6.46906 7.64463 6.5515 7.82282 6.59113 8.01257C6.63075 8.20231 6.62651 8.3986 6.57873 8.58645L6.00409 10.8443C5.98611 10.9147 5.99278 10.9892 6.023 11.0553C6.05321 11.1214 6.10516 11.1751 6.17018 11.2076L6.59082 11.4176L9.58809 7.17182C9.74718 6.94655 9.95082 6.762 10.1818 6.62582ZM11.4545 6.36364H12.7273V1.27273H11.4545V6.36364Z" fill="#2C2C2C"/></svg>';
      }

      get #verifiedCheckSVG() {
        return '<svg class="yrv-verified-icon" width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.5 13C10.0899 13 13 10.0899 13 6.5C13 2.91015 10.0899 0 6.5 0C2.91015 0 0 2.91015 0 6.5C0 10.0899 2.91015 13 6.5 13Z" fill="#709525"/><path d="M3.4668 6.25919L5.82646 8.6666L9.9668 4.7666" stroke="white" stroke-width="1.3"/></svg>';
      }

      /* ------------------------------------------------------------------ */
      /*  Data fetching                                                      */
      /* ------------------------------------------------------------------ */
      async #fetchAll() {
        this.#state.loading = true;
        this.#state.error = null;
        this.innerHTML = this.#renderLoading();

        const [reviewsRes, qaRes, mediaRes, ratingsRes, starsRes] = await Promise.allSettled([
          this.#fetchReviews(1),
          this.#fetchQA(),
          this.#fetchMedia(),
          this.#fetchRatings(),
          this.#fetchStarDistribution(),
        ]);

        const allFailed = [reviewsRes, qaRes, mediaRes, ratingsRes, starsRes].every(
          (r) => r.status === 'rejected'
        );
        if (allFailed) {
          this.#state.error = 'Unable to load reviews. Please try again later.';
        }

        this.#state.loading = false;
        this.#render();
      }

      async #fetchReviews(page, star) {
        const s = this.#state;
        let url = `${this.#base}/v3/storefront/store/${this.#key}/product/${this.#productId}/reviews?page=${page}&perPage=${s.perPage}&sort=date,images,badge,rating`;
        if (star) url += `&star=${star}`;

        const res = await fetch(url);
        if (!res.ok) throw new Error('Reviews fetch failed');
        const data = await res.json();

        if (page === 1) {
          s.reviews = data.reviews || [];
        } else {
          s.reviews = [...s.reviews, ...(data.reviews || [])];
        }
        s.reviewPage = data.pagination?.page || page;
        s.totalReviews = data.pagination?.total ?? s.totalReviews;
        if (data.bottomline) {
          s.averageScore = data.bottomline.averageScore ?? s.averageScore;
        }

        // The v3 CDN endpoint caches vote counts and may return stale zeros.
        // Patch with fresh counts from the non-cached v1 widget endpoint.
        try {
          const v1Res = await fetch(`https://api.yotpo.com/v1/widget/${this.#key}/products/${this.#productId}/reviews.json?per_page=${s.perPage}&page=${page}`);
          if (v1Res.ok) {
            const v1Data = await v1Res.json();
            const voteMap = new Map((v1Data.response?.reviews || []).map(r => [r.id, r]));
            for (const review of s.reviews) {
              const v1 = voteMap.get(review.id);
              if (v1) {
                review.votesUp = v1.votes_up ?? 0;
                review.votesDown = v1.votes_down ?? 0;
              }
            }
          }
        } catch { /* vote counts stay as-is from v3 */ }
      }

      async #fetchQA() {
        const url = `${this.#base}/v1/widget/${this.#key}/products/${this.#productId}/questions?page=1&per_page=50`;
        const res = await fetch(url);
        if (!res.ok) throw new Error('Q&A fetch failed');
        const data = await res.json();
        this.#state.qa = data.response?.questions || [];
      }

      async #fetchMedia() {
        const url = `${this.#base}/v3/storefront/stores/${this.#key}/products/${this.#productId}/reviewsMedia?page=1&perPage=20`;
        const res = await fetch(url);
        if (!res.ok) throw new Error('Media fetch failed');
        const data = await res.json();
        this.#state.images = data.response?.reviewsMedia || [];
      }

      async #fetchRatings() {
        const url = `${this.#base}/v3/storefront/store/${this.#key}/product/${this.#productId}/ratings`;
        const res = await fetch(url);
        if (!res.ok) throw new Error('Ratings fetch failed');
        const data = await res.json();
        const bl = data.bottomline || {};
        this.#state.totalReviews = bl.totalReviews ?? this.#state.totalReviews;
        this.#state.averageScore = bl.averageScore ?? this.#state.averageScore;
      }

      async #fetchStarDistribution() {
        const url = `${this.#base}/v1/star_distribution/store/${this.#key}/product/${this.#productId}`;
        const res = await fetch(url);
        if (!res.ok) throw new Error('Star distribution fetch failed');
        const data = await res.json();
        this.#state.starDistribution = data || {};
      }

      /* ------------------------------------------------------------------ */
      /*  Render — full                                                      */
      /* ------------------------------------------------------------------ */
      #render() {
        if (this.#state.loading) {
          this.innerHTML = this.#renderLoading();
          return;
        }
        if (this.#state.error) {
          this.innerHTML = this.#renderError();
          this.#bindEvents();
          return;
        }

        /* Order per Figma: Reviews title → Uploaded images → Review cards → Q&A
           (the images block is rendered inside #renderReviewsSection, right
           below the "Reviews" heading) */
        this.innerHTML = `
          <div class="yrv-container">
            ${this.#renderReviewsSection()}
            ${this.#renderQASection()}
            ${this.#renderLightboxDialog()}
            ${this.#renderReviewFormDialog()}
            ${this.#renderQuestionFormDialog()}
          </div>
        `;
        this.#bindEvents();
        this.#positionQANav();
        this.#initImagesSlider();
      }

      #positionQANav() {
        if (window.innerWidth > 749) return;
        const nav = this.querySelector('.yrv-qa-nav');
        const cards = this.querySelector('.yrv-qa-cards');
        if (nav && cards) cards.after(nav);
      }

      /* ------------------------------------------------------------------ */
      /*  Render — reviews section                                           */
      /* ------------------------------------------------------------------ */
      #renderReviewsSection() {
        const s = this.#state;

        const filterOptions = [0, 5, 4, 3, 2, 1]
          .map((n) => {
            const label = n === 0 ? 'All Stars' : `${n} Star${n > 1 ? 's' : ''}`;
            const selected = s.ratingFilter === n ? 'selected' : '';
            return `<option value="${n}" ${selected}>${label}</option>`;
          })
          .join('');

        const filtered = this.#getFilteredReviews();

        let cardsHTML = '';
        if (filtered.length === 0) {
          cardsHTML = this.#renderEmpty('reviews');
        } else {
          cardsHTML = filtered.map((r) => this.#renderReviewCard(r)).join('');
        }

        const hasMore = s.reviews.length < s.totalReviews;

        const hasReviews = filtered.length > 0;

        return `
          <div class="yrv-section" id="product-reviews">
            <h2 class="yrv-tab-heading">Reviews</h2>
            ${this.#renderImagesSection()}
            ${hasReviews ? `<div class="yrv-cta-row">
              <div class="yrv-cta-row__left">
                <div class="yrv-search-wrap">
                  <input class="yrv-search-input" type="text" placeholder="Search reviews" value="${this.#escapeHTML(s.searchQuery)}" data-action="search" />
                  <button class="yrv-search-btn" type="button" data-action="search-submit" aria-label="Search reviews">
                    <svg width="15" height="15" viewBox="0 0 15 15" fill="none"><circle cx="6.5" cy="6.5" r="5.5" stroke="#252525" stroke-width="1.5"/><line x1="10.5" y1="10.5" x2="14" y2="14" stroke="#252525" stroke-width="1.5" stroke-linecap="round"/></svg>
                  </button>
                </div>
                <select class="yrv-filter-select" data-action="rating-filter">
                  ${filterOptions}
                </select>
              </div>
              <button class="yrv-btn-primary" data-action="write-review">Write a Review</button>
            </div>` : ''}
            <div class="yrv-cards-grid">
              ${cardsHTML}
            </div>
            ${hasMore && !s.searchQuery && hasReviews ? '<div class="yrv-load-more"><button class="yrv-btn-primary" data-action="load-more">Show All Reviews</button></div>' : ''}
          </div>
        `;
      }

      #renderReviewCard(review) {
        const name = this.#escapeHTML(review.user?.displayName || 'Anonymous');
        const title = this.#escapeHTML(review.title || '');
        const content = this.#escapeHTML(review.content || '');
        const date = this.#formatDate(review.createdAt);

        const verifiedHTML = `${this.#verifiedCheckSVG}<span class="yrv-verified-text">Verified Reviewer</span>`;

        let imagesHTML = '';
        if (review.imagesData && review.imagesData.length > 0) {
          const thumbs = review.imagesData
            .map(
              (img) =>
                `<img class="yrv-review-thumb" src="${this.#escapeHTML(img.thumbUrl || img.originalUrl || '')}" alt="Review image" loading="lazy" data-full="${this.#escapeHTML(img.originalUrl || img.thumbUrl || '')}" data-action="open-lightbox" />`
            )
            .join('');
          imagesHTML = `<div class="yrv-review-images">${thumbs}</div>`;
        }

        return `
          <article class="yrv-review-card" data-review-id="${review.id}">
            <div class="yrv-review-header">
              <div class="yrv-review-stars">${this.#renderStars(review.score)}</div>
              <time class="yrv-review-date">${date}</time>
            </div>
            ${title ? `<h4 class="yrv-review-title">${title}</h4>` : ''}
            <p class="yrv-review-content">${content}</p>
            ${imagesHTML}
            <div class="yrv-review-meta">
              <span class="yrv-review-author">${name}</span>
              ${verifiedHTML}
            </div>
            ${this.#renderTeamResponse(review.comment || review.comments?.[0] || review.store_comment)}
            ${this.#renderHelpful(review)}
            <div class="yrv-card-divider"></div>
          </article>
        `;
      }

      /* ------------------------------------------------------------------ */
      /*  Render — stars                                                     */
      /* ------------------------------------------------------------------ */
      #renderStars(score) {
        const rounded = Math.round(score);
        let html = '';
        for (let i = 1; i <= 5; i++) {
          const filled = i <= rounded ? 'yrv-star--filled' : 'yrv-star--empty';
          html += `<svg class="yrv-star ${filled}" width="16" height="16" viewBox="0 0 16 16"><path d="M8 0l2.47 5.01L16 5.81l-4 3.9.94 5.49L8 12.49l-4.94 2.71L4 9.71 0 5.81l5.53-.8L8 0z" fill="currentColor"/></svg>`;
        }
        return html;
      }

      /* ------------------------------------------------------------------ */
      /*  Render — team response                                             */
      /* ------------------------------------------------------------------ */
      #renderTeamResponse(comment) {
        let text = '';
        if (typeof comment === 'string') {
          text = comment;
        } else if (typeof comment === 'object' && comment) {
          text = comment.content || comment.body || comment.text || '';
        }
        // Only render a team reply when the store actually left one in Yotpo.
        // No fabricated fallback — otherwise every un-answered review shows a fake reply.
        if (!text.trim()) return '';
        return `
          <div class="yrv-team-response">
            <strong class="yrv-team-label">The Lehman's Team</strong>
            <p class="yrv-team-content">${this.#escapeHTML(text)}</p>
          </div>
        `;
      }

      /* ------------------------------------------------------------------ */
      /*  Render — helpful voting                                            */
      /* ------------------------------------------------------------------ */
      #renderHelpful(review) {
        return `
          <div class="yrv-helpful" data-review-id="${review.id}">
            <span class="yrv-helpful-label">Was this review helpful?</span>
            <button class="yrv-helpful-btn" data-action="vote-up" data-review-id="${review.id}" aria-label="Vote helpful">
              ${this.#thumbUpSVG} <span class="yrv-vote-count">${review.votesUp || 0}</span>
            </button>
            <button class="yrv-helpful-btn" data-action="vote-down" data-review-id="${review.id}" aria-label="Vote not helpful">
              ${this.#thumbDownSVG} <span class="yrv-vote-count">${review.votesDown || 0}</span>
            </button>
          </div>
        `;
      }

      /* ------------------------------------------------------------------ */
      /*  Render — uploaded images section                                   */
      /* ------------------------------------------------------------------ */
      #renderImagesSection() {
        const images = this.#state.images;
        if (!images || images.length === 0) return '';

        const thumbs = images
          .map(
            (img) =>
              `<img class="yrv-image-thumb" src="${this.#escapeHTML(img.thumbUrl || img.originalUrl || '')}" alt="Customer photo" loading="lazy" data-full="${this.#escapeHTML(img.originalUrl || img.thumbUrl || '')}" data-action="open-lightbox" />`
          )
          .join('');

        return `
          <div class="yrv-images-section">
            <h3 class="yrv-images-title">Uploaded Images</h3>
            <div class="yrv-images-grid" data-element="images-track">${thumbs}</div>
            <div class="yrv-images-slider" data-element="images-slider">
              <span class="yrv-images-slider-thumb" data-element="images-slider-thumb"></span>
            </div>
          </div>
        `;
      }

      /* ------------------------------------------------------------------ */
      /*  Uploaded images — horizontal scroller + custom slider bar          */
      /* ------------------------------------------------------------------ */
      #initImagesSlider() {
        const track = this.querySelector('[data-element="images-track"]');
        const slider = this.querySelector('[data-element="images-slider"]');
        const thumb = this.querySelector('[data-element="images-slider-thumb"]');
        if (!track || !slider || !thumb) return;

        const update = () => {
          const overflow = track.scrollWidth - track.clientWidth;
          if (overflow <= 1) { slider.style.display = 'none'; return; }
          slider.style.display = 'block';
          const thumbPct = Math.max((track.clientWidth / track.scrollWidth) * 100, 8);
          thumb.style.width = `${thumbPct}%`;
          const scrolled = track.scrollLeft / overflow;
          thumb.style.left = `${scrolled * (100 - thumbPct)}%`;
        };

        let dragging = false;
        const scrollFromPointer = (clientX) => {
          const rect = slider.getBoundingClientRect();
          const thumbW = thumb.offsetWidth;
          const usable = rect.width - thumbW;
          if (usable <= 0) return;
          let pos = (clientX - rect.left - thumbW / 2) / usable;
          pos = Math.max(0, Math.min(1, pos));
          track.scrollLeft = pos * (track.scrollWidth - track.clientWidth);
        };

        track.addEventListener('scroll', update, { passive: true });
        slider.addEventListener('pointerdown', (e) => {
          dragging = true;
          slider.setPointerCapture(e.pointerId);
          scrollFromPointer(e.clientX);
        });
        slider.addEventListener('pointermove', (e) => { if (dragging) scrollFromPointer(e.clientX); });
        slider.addEventListener('pointerup', (e) => { dragging = false; slider.releasePointerCapture(e.pointerId); });

        if (window.ResizeObserver) {
          new ResizeObserver(update).observe(track);
        } else {
          window.addEventListener('resize', update);
        }
        track.querySelectorAll('img').forEach((img) => {
          if (!img.complete) img.addEventListener('load', update, { once: true });
        });
        update();
      }

      /* ------------------------------------------------------------------ */
      /*  Render — lightbox dialog                                           */
      /* ------------------------------------------------------------------ */
      #renderLightboxDialog() {
        return `
          <dialog class="yrv-lightbox" data-element="lightbox">
            <div class="yrv-lightbox-inner">
              <button class="yrv-lightbox-close" data-action="close-lightbox" aria-label="Close">&times;</button>
              <img class="yrv-lightbox-img" src="" alt="Review image full size" />
            </div>
          </dialog>
        `;
      }

      /* ------------------------------------------------------------------ */
      /*  Render — Q&A section                                               */
      /* ------------------------------------------------------------------ */
      #renderQASection() {
        const questions = this.#state.qa;
        if (!questions || questions.length === 0) {
          return `
            <div class="yrv-section yrv-qa-section" id="product-qa">
              <h2 class="yrv-tab-heading">Q&amp;A</h2>
              ${this.#renderEmpty('qa')}
            </div>
          `;
        }

        const perPage = window.innerWidth <= 749 ? 1 : 3;
        const start = this.#state.qaWindowStart;
        const cards = questions
          .map((q, i) => {
            const visible = i >= start && i < start + perPage;
            return `<div class="yrv-qa-card ${visible ? '' : 'yrv-hidden'}" data-qa-index="${i}">${this.#renderQACard(q)}</div>`;
          })
          .join('');

        const showPrev = start > 0;
        const showNext = start + perPage < questions.length;

        const prevSvg = `<svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7 1L1 7L7 13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
        const nextSvg = `<svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L7 7L1 13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`;

        return `
          <div class="yrv-section yrv-qa-section" id="product-qa">
            <div class="yrv-qa-header">
              <h2 class="yrv-tab-heading">Q&amp;A</h2>
              <div class="yrv-qa-nav">
                <button class="yrv-qa-arrow" data-action="qa-prev" ${showPrev ? '' : 'disabled'} aria-label="Previous questions">${prevSvg}</button>
                <button class="yrv-qa-arrow" data-action="qa-next" ${showNext ? '' : 'disabled'} aria-label="Next questions">${nextSvg}</button>
              </div>
            </div>
            <div class="yrv-qa-cards">${cards}</div>
            <div class="yrv-load-more">
              <button class="yrv-btn-primary" data-action="ask-question">Ask a Question</button>
            </div>
          </div>
        `;
      }

      #renderQACard(question) {
        const content = this.#escapeHTML(question.content || '');
        const asker = this.#escapeHTML(question.asker?.display_name || 'Someone');

        let answerText = '';
        let answererName = "The Lehman's Team";
        if (question.answers && question.answers.length > 0) {
          const a = question.answers[0];
          answerText = this.#escapeHTML(a.content || '');
          const isTeam = a.store_owner_comment === true;
          if (!isTeam) {
            answererName = this.#escapeHTML(
              typeof a.answerer === 'object' ? a.answerer.display_name || 'Store' : 'Store'
            );
          }
        }
        const answerHTML = answerText
          ? `
          <div class="yrv-qa-answer">
            <strong class="yrv-qa-answerer">${answererName}</strong>
            <p class="yrv-qa-answer-text"><strong>A:</strong> ${answerText}</p>
          </div>`
          : '';

        return `
          <div class="yrv-qa-card__author">
            <div class="yrv-qa-card__avatar">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.9849 15.6042C14.4026 14.8332 13.6493 14.208 12.7842 13.7778C11.9192 13.3476 10.9661 13.1241 9.99993 13.125C9.0338 13.1241 8.08067 13.3476 7.21561 13.7778C6.35056 14.208 5.59721 14.8332 5.01493 15.6042M14.9849 15.6042C16.1212 14.5935 16.9225 13.2613 17.2842 11.7842C17.646 10.3072 17.5501 8.75507 17.0095 7.33373C16.4688 5.91239 15.5089 4.68898 14.2569 3.82575C13.005 2.96251 11.5202 2.50024 9.99951 2.50024C8.47881 2.50024 6.99404 2.96251 5.7421 3.82575C4.49016 4.68898 3.5302 5.91239 2.98954 7.33373C2.44888 8.75507 2.35306 10.3072 2.71478 11.7842C3.0765 13.2613 3.87868 14.5935 5.01493 15.6042M14.9849 15.6042C13.6133 16.8276 11.838 17.5026 9.99993 17.5C8.16162 17.5028 6.38679 16.8278 5.01493 15.6042M12.4999 8.125C12.4999 8.78804 12.2365 9.42392 11.7677 9.89277C11.2989 10.3616 10.663 10.625 9.99993 10.625C9.33689 10.625 8.701 10.3616 8.23216 9.89277C7.76332 9.42392 7.49993 8.78804 7.49993 8.125C7.49993 7.46196 7.76332 6.82607 8.23216 6.35723C8.701 5.88839 9.33689 5.625 9.99993 5.625C10.663 5.625 11.2989 5.88839 11.7677 6.35723C12.2365 6.82607 12.4999 7.46196 12.4999 8.125Z" stroke="#252525" stroke-linecap="round" stroke-linejoin="round"/></svg>
            </div>
            <span class="yrv-qa-card__name">${asker}</span>
            <div class="yrv-qa-card__verified">
              ${this.#verifiedCheckSVG}
              <span class="yrv-verified-text">Verified Reviewer</span>
            </div>
          </div>
          <p class="yrv-qa-question-text"><strong>Q:</strong> ${content}</p>${answerHTML}
        `;
      }

      /* ------------------------------------------------------------------ */
      /*  Render — Write a Review form dialog                                */
      /* ------------------------------------------------------------------ */
      #renderReviewFormDialog() {
        return `
          <dialog class="yrv-form-dialog" data-element="review-form">
            <div class="yrv-form-dialog__inner">
              <button class="yrv-form-dialog__close" data-action="close-review-form" aria-label="Close" type="button">&times;</button>
              <h3 class="yrv-form-dialog__title">Write a Review</h3>
              <form class="yrv-form" data-form="review">
                <label class="yrv-form__label">Rating
                  <div class="yrv-star-picker" data-element="star-picker">
                    ${[1,2,3,4,5].map(n => `<button type="button" class="yrv-star-picker__star" data-score="${n}" aria-label="${n} star${n>1?'s':''}">
                      <svg width="24" height="24" viewBox="0 0 16 16"><path d="M8 0l2.47 5.01L16 5.81l-4 3.9.94 5.49L8 12.49l-4.94 2.71L4 9.71 0 5.81l5.53-.8L8 0z" fill="currentColor"/></svg>
                    </button>`).join('')}
                  </div>
                  <input type="hidden" name="review_score" value="0" required />
                </label>
                <label class="yrv-form__label">Name
                  <input class="yrv-form__input" type="text" name="display_name" required placeholder="Your name" />
                </label>
                <label class="yrv-form__label">Email
                  <input class="yrv-form__input" type="email" name="email" required placeholder="your@email.com" />
                </label>
                <label class="yrv-form__label">Review Title
                  <input class="yrv-form__input" type="text" name="review_title" required placeholder="Summarize your experience" />
                </label>
                <label class="yrv-form__label">Review
                  <textarea class="yrv-form__textarea" name="review_content" required placeholder="Tell us about your experience" rows="4"></textarea>
                </label>
                <div class="yrv-form__actions">
                  <button class="yrv-btn-primary" type="submit">Submit Review</button>
                </div>
                <div class="yrv-form__message" data-element="review-message"></div>
              </form>
            </div>
          </dialog>
        `;
      }

      /* ------------------------------------------------------------------ */
      /*  Render — Ask a Question form dialog                                */
      /* ------------------------------------------------------------------ */
      #renderQuestionFormDialog() {
        return `
          <dialog class="yrv-form-dialog" data-element="question-form">
            <div class="yrv-form-dialog__inner">
              <button class="yrv-form-dialog__close" data-action="close-question-form" aria-label="Close" type="button">&times;</button>
              <h3 class="yrv-form-dialog__title">Ask a Question</h3>
              <form class="yrv-form" data-form="question">
                <label class="yrv-form__label">Name
                  <input class="yrv-form__input" type="text" name="author_name" required placeholder="Your name" />
                </label>
                <label class="yrv-form__label">Email
                  <input class="yrv-form__input" type="email" name="author_email" required placeholder="your@email.com" />
                </label>
                <label class="yrv-form__label">Question
                  <textarea class="yrv-form__textarea" name="question_content" required placeholder="What would you like to know?" rows="4"></textarea>
                </label>
                <div class="yrv-form__actions">
                  <button class="yrv-btn-primary" type="submit">Submit Question</button>
                </div>
                <div class="yrv-form__message" data-element="question-message"></div>
              </form>
            </div>
          </dialog>
        `;
      }

      /* ------------------------------------------------------------------ */
      /*  Render — loading skeleton                                          */
      /* ------------------------------------------------------------------ */
      #renderLoading() {
        const card = '<div class="yrv-skeleton-card"><div class="yrv-skeleton-line yrv-skeleton-line--short"></div><div class="yrv-skeleton-line"></div><div class="yrv-skeleton-line"></div><div class="yrv-skeleton-line yrv-skeleton-line--medium"></div></div>';
        return `<div class="yrv-container"><div class="yrv-section"><div class="yrv-tab-heading" style="border-color:transparent;color:transparent;">Reviews</div><div class="yrv-loading">${card}${card}${card}</div></div></div>`;
      }

      /* ------------------------------------------------------------------ */
      /*  Render — empty states                                              */
      /* ------------------------------------------------------------------ */
      #renderEmpty(type) {
        if (type === 'reviews') {
          return `
            <div class="yrv-empty">
              <p>No reviews yet. Be the first to share your experience!</p>
              <button class="yrv-btn-primary" data-action="write-review">Write a Review</button>
            </div>
          `;
        }
        if (type === 'qa') {
          return `
            <div class="yrv-empty">
              <p>No questions yet. Have a question about this product?</p>
              <button class="yrv-btn-primary" data-action="ask-question">Ask a Question</button>
            </div>
          `;
        }
        return '<div class="yrv-empty"><p>Nothing to show.</p></div>';
      }

      /* ------------------------------------------------------------------ */
      /*  Render — error                                                     */
      /* ------------------------------------------------------------------ */
      #renderError() {
        return `
          <div class="yrv-error">
            <p>${this.#escapeHTML(this.#state.error)}</p>
            <button class="yrv-btn-primary" data-action="retry">Try Again</button>
          </div>
        `;
      }

      /* ------------------------------------------------------------------ */
      /*  Events                                                             */
      /* ------------------------------------------------------------------ */
      #bindEvents() {
        this.addEventListener('click', (e) => {
          const target = e.target.closest('[data-action]');
          if (!target) return;
          const action = target.dataset.action;

          if (action === 'load-more') {
            this.#onLoadMore();
          } else if (action === 'write-review') {
            this.#openWriteReview();
          } else if (action === 'ask-question') {
            this.#openAskQuestion();
          } else if (action === 'vote-up') {
            this.#voteHelpful(target.dataset.reviewId, 'up');
          } else if (action === 'vote-down') {
            this.#voteHelpful(target.dataset.reviewId, 'down');
          } else if (action === 'open-lightbox') {
            this.#onOpenLightbox(e);
          } else if (action === 'close-lightbox') {
            this.#onCloseLightbox();
          } else if (action === 'close-review-form') {
            this.querySelector('[data-element="review-form"]')?.close();
          } else if (action === 'close-question-form') {
            this.querySelector('[data-element="question-form"]')?.close();
          } else if (action === 'qa-prev') {
            this.#onQANav(-(window.innerWidth <= 749 ? 1 : 3));
          } else if (action === 'qa-next') {
            this.#onQANav(window.innerWidth <= 749 ? 1 : 3);
          } else if (action === 'search-submit') {
            const input = this.querySelector('[data-action="search"]');
            if (input) { this.#state.searchQuery = input.value.trim(); this.#onSearch(); }
          } else if (action === 'retry') {
            this.#fetchAll();
          }
        });

        const filterSelect = this.querySelector('[data-action="rating-filter"]');
        if (filterSelect) {
          filterSelect.addEventListener('change', async (e) => {
            this.#state.ratingFilter = parseInt(e.target.value, 10);
            /* Load all reviews so filtering covers everything */
            if (this.#state.reviews.length < this.#state.totalReviews) {
              const totalPages = Math.ceil(this.#state.totalReviews / this.#state.perPage);
              const fetches = [];
              for (let p = 2; p <= totalPages; p++) {
                fetches.push(this.#fetchReviews(p));
              }
              if (fetches.length > 0) await Promise.allSettled(fetches);
            }
            this.#updateReviewCards();
          });
        }

        const searchInput = this.querySelector('[data-action="search"]');
        if (searchInput) {
          searchInput.addEventListener('input', (e) => {
            clearTimeout(this.#debounceTimer);
            this.#debounceTimer = setTimeout(() => {
              this.#state.searchQuery = e.target.value.trim();
              this.#onSearch();
            }, 300);
          });
          searchInput.addEventListener('keydown', (e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              this.#state.searchQuery = e.target.value.trim();
              this.#onSearch();
            }
          });
        }

        const dialog = this.querySelector('[data-element="lightbox"]');
        if (dialog) {
          dialog.addEventListener('click', (e) => {
            if (e.target === dialog) dialog.close();
          });
        }

        /* Close form dialogs on backdrop click */
        this.querySelectorAll('.yrv-form-dialog').forEach((d) => {
          d.addEventListener('click', (e) => { if (e.target === d) d.close(); });
        });

        /* Star picker */
        const starPicker = this.querySelector('[data-element="star-picker"]');
        if (starPicker) {
          starPicker.addEventListener('click', (e) => {
            const starBtn = e.target.closest('.yrv-star-picker__star');
            if (!starBtn) return;
            const score = parseInt(starBtn.dataset.score, 10);
            const hidden = this.querySelector('[name="review_score"]');
            if (hidden) hidden.value = score;
            starPicker.querySelectorAll('.yrv-star-picker__star').forEach((s) => {
              const n = parseInt(s.dataset.score, 10);
              s.classList.toggle('yrv-star-picker__star--active', n <= score);
            });
          });
        }

        /* Review form submit */
        const reviewForm = this.querySelector('[data-form="review"]');
        if (reviewForm) {
          reviewForm.addEventListener('submit', (e) => {
            e.preventDefault();
            this.#submitReview(new FormData(reviewForm));
          });
        }

        /* Question form submit */
        const questionForm = this.querySelector('[data-form="question"]');
        if (questionForm) {
          questionForm.addEventListener('submit', (e) => {
            e.preventDefault();
            this.#submitQuestion(new FormData(questionForm));
          });
        }

        /* Q&A swipe */
        const qaCards = this.querySelector('.yrv-qa-cards');
        if (qaCards) {
          let touchStartX = 0;
          qaCards.addEventListener('touchstart', (e) => {
            touchStartX = e.changedTouches[0].clientX;
          }, { passive: true });
          qaCards.addEventListener('touchend', (e) => {
            const dx = e.changedTouches[0].clientX - touchStartX;
            if (Math.abs(dx) < 50) return;
            this.#onQANav(dx < 0 ? 1 : -1);
          }, { passive: true });
        }
      }

      /* ------------------------------------------------------------------ */
      /*  Actions                                                            */
      /* ------------------------------------------------------------------ */
      async #onLoadMore() {
        const nextPage = this.#state.reviewPage + 1;
        const star = this.#state.ratingFilter || undefined;
        await this.#fetchReviews(nextPage, star);
        this.#updateReviewCards();
      }

      #updateReviewCards() {
        const grid = this.querySelector('.yrv-cards-grid');
        if (!grid) return;

        const filtered = this.#getFilteredReviews();
        if (filtered.length === 0) {
          grid.innerHTML = this.#renderEmpty('reviews');
        } else {
          grid.innerHTML = filtered.map((r) => this.#renderReviewCard(r)).join('');
        }

        const loadMore = this.querySelector('.yrv-load-more');
        if (loadMore) {
          const hasMore = this.#state.reviews.length < this.#state.totalReviews;
          loadMore.style.display = hasMore && !this.#state.searchQuery ? '' : 'none';
        }
      }

      async #onSearch() {
        const query = this.#state.searchQuery;
        if (query && this.#state.reviews.length < this.#state.totalReviews) {
          /* Fetch all remaining reviews so search covers everything */
          const s = this.#state;
          const totalPages = Math.ceil(s.totalReviews / s.perPage);
          const fetches = [];
          for (let p = 2; p <= totalPages; p++) {
            if (s.reviews.length < p * s.perPage) {
              fetches.push(this.#fetchReviews(p, s.ratingFilter || undefined));
            }
          }
          if (fetches.length > 0) await Promise.allSettled(fetches);
        }
        this.#updateReviewCards();
      }

      #getFilteredReviews() {
        let reviews = this.#state.reviews;
        const rating = this.#state.ratingFilter;
        if (rating) {
          reviews = reviews.filter((r) => Math.round(r.score) === rating);
        }
        const query = this.#state.searchQuery.toLowerCase();
        if (query) {
          reviews = reviews.filter((r) => {
            const title = (r.title || '').toLowerCase();
            const content = (r.content || '').toLowerCase();
            const author = (r.user?.displayName || '').toLowerCase();
            return title.includes(query) || content.includes(query) || author.includes(query);
          });
        }
        return reviews;
      }

      #onOpenLightbox(e) {
        const img = e.target.closest('[data-action="open-lightbox"]');
        if (!img) return;
        const dialog = this.querySelector('[data-element="lightbox"]');
        const dialogImg = dialog?.querySelector('.yrv-lightbox-img');
        if (dialog && dialogImg) {
          dialogImg.src = img.dataset.full || img.src;
          dialog.showModal();
        }
      }

      #onCloseLightbox() {
        const dialog = this.querySelector('[data-element="lightbox"]');
        if (dialog) dialog.close();
      }

      #onQANav(delta) {
        const s = this.#state;
        const perPage = window.innerWidth <= 749 ? 1 : 3;
        s.qaWindowStart = Math.max(0, Math.min(s.qaWindowStart + delta, s.qa.length - 1));

        this.querySelectorAll('.yrv-qa-card').forEach((card) => {
          const idx = parseInt(card.dataset.qaIndex, 10);
          card.classList.toggle('yrv-hidden', idx < s.qaWindowStart || idx >= s.qaWindowStart + perPage);
        });

        const prevBtn = this.querySelector('[data-action="qa-prev"]');
        const nextBtn = this.querySelector('[data-action="qa-next"]');
        if (prevBtn) prevBtn.disabled = s.qaWindowStart <= 0;
        if (nextBtn) nextBtn.disabled = s.qaWindowStart + perPage >= s.qa.length;
      }

      async #voteHelpful(reviewId, type) {
        const review = this.#state.reviews.find((r) => String(r.id) === String(reviewId));
        if (!review) return;

        const key = type === 'up' ? 'votesUp' : 'votesDown';
        review[key] = (review[key] || 0) + 1;

        const helpfulEl = this.querySelector(`.yrv-helpful[data-review-id="${reviewId}"]`);
        if (helpfulEl) {
          const btn = helpfulEl.querySelector(`[data-action="vote-${type}"]`);
          const countEl = btn?.querySelector('.yrv-vote-count');
          if (countEl) countEl.textContent = review[key];
        }

        try {
          await fetch(`https://api.yotpo.com/reviews/${reviewId}/vote/${type}`, { method: 'POST' });
        } catch {
          review[key] = Math.max(0, review[key] - 1);
          if (helpfulEl) {
            const btn = helpfulEl.querySelector(`[data-action="vote-${type}"]`);
            const countEl = btn?.querySelector('.yrv-vote-count');
            if (countEl) countEl.textContent = review[key];
          }
        }
      }

      /* ------------------------------------------------------------------ */
      /*  Form dialogs                                                       */
      /* ------------------------------------------------------------------ */
      #openWriteReview() {
        const dialog = this.querySelector('[data-element="review-form"]');
        if (dialog) dialog.showModal();
      }

      #openAskQuestion() {
        const dialog = this.querySelector('[data-element="question-form"]');
        if (dialog) dialog.showModal();
      }

      /* ------------------------------------------------------------------ */
      /*  Form submissions                                                   */
      /* ------------------------------------------------------------------ */
      async #submitReview(formData) {
        const msgEl = this.querySelector('[data-element="review-message"]');
        const submitBtn = this.querySelector('[data-form="review"] [type="submit"]');
        const score = parseInt(formData.get('review_score'), 10);

        if (!score || score < 1) {
          if (msgEl) { msgEl.textContent = 'Please select a star rating.'; msgEl.className = 'yrv-form__message yrv-form__message--error'; }
          return;
        }

        if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Submitting…'; }

        try {
          const res = await fetch('https://api.yotpo.com/v1/widget/reviews', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              appkey: this.#key,
              sku: this.#productId,
              product_title: this.dataset.productTitle || '',
              product_url: this.dataset.productUrl || '',
              display_name: formData.get('display_name'),
              email: formData.get('email'),
              review_content: formData.get('review_content'),
              review_title: formData.get('review_title'),
              review_score: score,
            }),
          });
          const data = await res.json();

          if (res.ok && data.code === 200) {
            if (msgEl) { msgEl.textContent = 'Thank you! Your review has been submitted and will appear after moderation.'; msgEl.className = 'yrv-form__message yrv-form__message--success'; }
            this.querySelector('[data-form="review"]')?.reset();
            this.querySelector('[data-element="star-picker"]')?.querySelectorAll('.yrv-star-picker__star').forEach((s) => s.classList.remove('yrv-star-picker__star--active'));
          } else {
            throw new Error(data.message || 'Submission failed');
          }
        } catch (err) {
          if (msgEl) { msgEl.textContent = 'Something went wrong. Please try again.'; msgEl.className = 'yrv-form__message yrv-form__message--error'; }
        } finally {
          if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = 'Submit Review'; }
        }
      }

      async #submitQuestion(formData) {
        const msgEl = this.querySelector('[data-element="question-message"]');
        const submitBtn = this.querySelector('[data-form="question"] [type="submit"]');

        if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Submitting…'; }

        try {
          const res = await fetch('https://api.yotpo.com/questions/send_confirmation_mail', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              appkey: this.#key,
              sku: this.#productId,
              product_title: this.dataset.productTitle || '',
              product_url: this.dataset.productUrl || '',
              product_image_url: this.dataset.productImage || '',
              display_name: formData.get('author_name'),
              email: formData.get('author_email'),
              review_content: formData.get('question_content'),
              prevent_duplicate_review: true,
            }),
          });
          const data = await res.json().catch(() => ({}));

          if (res.ok && data.status?.code === 200) {
            if (msgEl) {
              msgEl.textContent = 'Thank you! Check your email to confirm your question. It will appear after verification.';
              msgEl.className = 'yrv-form__message yrv-form__message--success';
            }
            this.querySelector('[data-form="question"]')?.reset();
          } else {
            throw new Error(data.status?.message || data.message || 'Submission failed');
          }
        } catch (err) {
          if (msgEl) {
            msgEl.textContent = 'Something went wrong. Please try again.';
            msgEl.className = 'yrv-form__message yrv-form__message--error';
          }
          console.error('[yotpo-custom] Question submit failed:', err);
        } finally {
          if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = 'Submit Question'; }
        }
      }

      /* ------------------------------------------------------------------ */
      /*  Utilities                                                          */
      /* ------------------------------------------------------------------ */
      #formatDate(dateStr) {
        if (!dateStr) return '';
        const d = new Date(dateStr);
        if (isNaN(d.getTime())) return '';
        const mm = String(d.getMonth() + 1).padStart(2, '0');
        const dd = String(d.getDate()).padStart(2, '0');
        const yy = String(d.getFullYear()).slice(-2);
        return `${mm}/${dd}/${yy}`;
      }

      #escapeHTML(str) {
        if (!str) return '';
        return String(str)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#39;');
      }
    }
  );
}
